import { render, staticRenderFns } from "./preview.vue?vue&type=template&id=65e6cef8&scoped=true&"
import script from "./preview.vue?vue&type=script&lang=js&"
export * from "./preview.vue?vue&type=script&lang=js&"
import style0 from "./preview.vue?vue&type=style&index=0&id=65e6cef8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e6cef8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/baikaifa/Desktop/codes/baikaifa-overwrite-skeleton-webpack-plugin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65e6cef8')) {
      api.createRecord('65e6cef8', component.options)
    } else {
      api.reload('65e6cef8', component.options)
    }
    module.hot.accept("./preview.vue?vue&type=template&id=65e6cef8&scoped=true&", function () {
      api.rerender('65e6cef8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "preview/components/preview.vue"
export default component.exports